
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/svb",
      function () {
        return require("private-next-pages/docs/auth/partnerships/svb.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/svb"])
      });
    }
  